const loginDefaultValues = {};

export default loginDefaultValues;
